import script from "./EditInfoForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditInfoForm.vue?vue&type=script&lang=ts&setup=true"

import "./EditInfoForm.vue?vue&type=style&index=0&id=1e762db8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e762db8"]])

export default __exports__